module.exports = "../fonts/HelveticaNeueLTW01-75Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-75Bold.woff
// module id = gtsn
// module chunks = 1